import React from 'react'
import PropTypes from 'prop-types'

const IconCheck = ({ className, onClick }) => {
	return (
		<svg
			className={className}
			onClick={onClick}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			stroke='#969FA8'
		>
			<path
				d="M19.1111 7.11108L9.33336 16.8889L4.88892 12.4444"
				stroke="inherit"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)

}

IconCheck.propTypes = {
	className: PropTypes.string,
	onClick: PropTypes.func
}

export default IconCheck
